import { useState } from 'react';
import DeleteIcon from '@mui/icons-material/DeleteOutlined';
import EditIcon from '@mui/icons-material/Edit';
import { FieldArray, useFormikContext } from 'formik';
import { v4 as uuidv4 } from 'uuid';
import { GridToolbarContainer, GridActionsCellItem, useGridApiRef } from '@mui/x-data-grid-premium';

import { dataGridPremiumColumns } from '../../utils/helper';
import { DataGridIdentifiers, AddButtonUi, DatagridPremiumUi, GridCellExpand } from '../Interface';
import DynamicFormCreatorDynFieldsDialog from './DynamicFormCreatorDynFieldsDialog';
import { DynmicFormFieldTypeOptions } from '../../config/DynmicFormFieldType';

const EditToolbar = (props) => {
  const { disabled, push, defaultDynamicFormField, setSelectedIndex } = props;
  const { values } = useFormikContext();

  const handleClick = () => {
    defaultDynamicFormField.id = uuidv4();
    defaultDynamicFormField.isNew = true;
    defaultDynamicFormField.quantityUnitId = null;
    const lengthBeforePush = values.dynamicFormField.length;
    push(defaultDynamicFormField);

    setSelectedIndex(lengthBeforePush);
  };

  return (
    <GridToolbarContainer>
      <AddButtonUi disabled={disabled} onClick={handleClick} />
    </GridToolbarContainer>
  );
};
const DynamicFormCreatorDynFields = (props) => {
  const { disabled, defaultDynamicFormField, selectedValues } = props;
  const apiRef = useGridApiRef();
  const { values } = useFormikContext();

  const [selectedIndex, setSelectedIndex] = useState(null);

  const getValueIndex = (values, id) => {
    return values.dynamicFormField.findIndex((rc) => rc.id === id);
  };

  const renderCellExpand = (data) => {
    return <GridCellExpand value={data.value || ''} width={data.colDef.computedWidth} />;
  };

  const columns = (remove) => {
    return dataGridPremiumColumns([
      {
        field: 'visOrder',
        headerName: 'Sorrend',
      },
      {
        field: 'name',
        headerName: 'Mező neve',
        type: 'string',
        sortable: false,
      },

      {
        field: 'type',
        headerName: 'Típus',
        type: 'string',
        sortable: false,
        renderCell: (data) => {
          return DynmicFormFieldTypeOptions.find((option) => option.value === data.value)?.label || '';
        },
      },

      {
        field: 'staticText',
        headerName: 'Statikus szöveg',
        type: 'string',
        sortable: false,
        renderCell: renderCellExpand,
      },
      {
        field: 'actions',
        type: 'actions',
        headerName: 'Szerk.',
        cellClassName: 'actions',
        sortable: false,
        getActions: ({ id, row }) => {
          return [
            <GridActionsCellItem
              icon={<DeleteIcon />}
              label="Delete"
              onClick={() => {
                const valueIndex = getValueIndex(values, id);
                return remove(valueIndex);
              }}
              color="inherit"
              disabled={disabled}
            />,
            <GridActionsCellItem
              icon={<EditIcon />}
              label="Edit"
              onClick={() => {
                const valueIndex = getValueIndex(values, id);
                setSelectedIndex(valueIndex);
              }}
              color="inherit"
              disabled={disabled}
            />,
          ];
        },
      },
    ]);
  };

  return (
    <>
      <div className="overflow-x-auto">
        <div className="align-middle">
          <div className="overflow-hidden shadow ring-1 ring-black ring-opacity-5 sm:rounded-lg">
            <FieldArray name="dynamicFormField">
              {({ remove, push }) => (
                <>
                  <DatagridPremiumUi
                    apiRef={apiRef}
                    datagridIdentifier={DataGridIdentifiers.DynamicFormField}
                    height={480}
                    columns={columns(remove)}
                    rows={values?.dynamicFormField ?? []}
                    slots={{
                      toolbar: EditToolbar,
                    }}
                    slotProps={{
                      toolbar: {
                        disabled,
                        push,
                        defaultDynamicFormField,
                        setSelectedIndex,
                      },
                    }}
                    onCellDoubleClick={(_params, event) => {
                      event.defaultMuiPrevented = true;
                    }}
                    headerFilters={false}
                    getRowHeight={() => 'auto'}
                  />
                  <DynamicFormCreatorDynFieldsDialog
                    selectedIndex={selectedIndex}
                    open={selectedIndex != null}
                    onClose={() => setSelectedIndex(null)}
                    remove={remove}
                    getValueIndex={getValueIndex}
                    {...props}
                  />
                </>
              )}
            </FieldArray>
          </div>
        </div>
      </div>
    </>
  );
};

export default DynamicFormCreatorDynFields;
